import { AnimatePresence } from 'framer-motion'
import { useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CURRENCY } from '@/lib/consts'
import Button from '@/ui/Button'
import Loader from '@/ui/Loader'

import useCheckout from '../Checkout/hooks/useCheckout'
import MenuCategory from './components/MenuCategory'
import MenuItem from './components/MenuItem'
import ProductModal from './components/ProductModal'
import { useMenuCategories, useMenuItems } from './hooks/useMenu'
import {
  MenuBody,
  MenuContent,
  MenuFooter,
  MenuGrid,
  MenuSeparator,
  MenuSidebar,
  MenuSummary,
  MenuSummaryTitle,
  MenuSummaryValue,
  MenuWrapper
} from './Menu.styles'

const Menu = ({ t }) => {
  const { cartTotal, cart } = useCheckout()
  const { data: categories, isLoading: isCategoriesLoading } = useMenuCategories()
  const { data: menu, isLoading: isMenuLoading } = useMenuItems()

  const [activeCategory, setActiveCategory] = useState(null)
  const [activeProduct, setActiveProduct] = useState(null)

  const navigate = useNavigate()

  const filteredMenu = useMemo(() => {
    if (!menu) return []
    if (!activeCategory) return menu
    return menu.filter(item => item.category.id === activeCategory)
  }, [activeCategory, menu])

  useEffect(() => {
    if (categories) setActiveCategory(categories[0]?.id || null)
  }, [categories])

  useEffect(() => {
    return () => {
      setActiveProduct(null)
    }
  }, [])

  return (
    <MenuWrapper>
      {(isMenuLoading || isCategoriesLoading) && <Loader />}
      <MenuBody>
        <MenuSidebar>
          {categories?.map(item => (
            <MenuCategory
              key={item.id}
              active={activeCategory === item.id}
              onClick={() => setActiveCategory(item.id)}
              icon={item.icon}
              label={item.name}
            />
          ))}
        </MenuSidebar>
        <MenuSeparator />
        <MenuContent>
          <MenuGrid>
            {filteredMenu.map(item => (
              <MenuItem key={item.id} {...item} onClick={() => setActiveProduct(item)} />
            ))}
          </MenuGrid>
        </MenuContent>
      </MenuBody>
      <MenuFooter>
        <Button variant="outline-dark" onClick={() => navigate('/')}>
          {t('finish')}
        </Button>
        <MenuSummary>
          <MenuSummaryTitle>{t('yourOrder')}</MenuSummaryTitle>
          <MenuSummaryValue>
            {cartTotal.toFixed(2)} {CURRENCY}
          </MenuSummaryValue>
        </MenuSummary>
        <Button onClick={() => navigate('/checkout')} size="lg" disabled={cart.length === 0}>
          {t('makeOrder')}
        </Button>
      </MenuFooter>

      <AnimatePresence mode="wait">
        {activeProduct && (
          <ProductModal product={activeProduct} title={activeProduct.name} onClose={() => setActiveProduct(null)}></ProductModal>
        )}
      </AnimatePresence>
    </MenuWrapper>
  )
}

export default withTranslation()(Menu)
